<template>
  <div>
    <div class="c-paster-modal">
      <div v-if="value" class="paster-warp">
        <div class="image-warp">
          <img
            ref="image"
            :src="value"
            alt=""
            :style="{ opacity: opacity / 100 }"
            :class="{ 'vertical-img': height < (width * 45) / 80 }"
            @load="loaded"
          />
        </div>
        <span @click.stop="clear" class="c-close"></span>
      </div>
      <ElButton v-else type="primary" @click.stop="model = true">选择贴纸</ElButton>

      <manager v-model="model" :type="9" :operator-data="operatorData" @on-select="handleBack" />
    </div>
    <div v-if="!validate" class="g-error-text">贴纸不能为空</div>
  </div>
</template>
<script>
import { isArray, isEmpty } from '@/common/js/utils'
import { getSysMember } from '@/api/common.model'
import Manager from './manager.vue'
export default {
  name: 'PasterModal',
  components: { Manager },
  props: {
    value: {
      type: [Number, String]
    },
    opacity: {
      type: Number,
      default: 100
    },
    verify: {
      type: Boolean
    }
  },
  computed: {
    validate() {
      return this.verify ? !isEmpty(this.value) : true
    }
  },
  data() {
    return {
      model: null,
      width: 0,
      height: 0,
      operatorData: []
    }
  },
  methods: {
    loaded() {
      const { width, height } = this.$refs.image
      this.width = width || 0
      this.height = height || 0
    },
    clear() {
      this.$emit('input', '')
      this.width = 0
      this.height = 0
    },
    handleBack(ret) {
      const { source_url, id } = ret.items.pop()
      this.$emit('input', source_url)
      this.$emit('on-select', id)
      this.model = false
    },
    preloadData() {
      Promise.all([getSysMember()]).then((data) => {
        const [operatorData] = data
        isArray(operatorData) && (this.operatorData = operatorData)
      })
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-paster-modal {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .paster-warp {
    display: flex;

    .image-warp {
      width: 80px;
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #3b3b3b;

      img {
        width: auto;
        height: 100%;

        &.vertical-img {
          width: 100%;
          height: auto;
        }
      }
    }

    .c-close {
      display: inline-block;
      width: 10px;
      height: 10px;
      cursor: pointer;
      background-color: #ff0000;
      border-radius: 20px;
      line-height: 18px;
      transform: translate(-5px, -5px);

      &::before {
        content: 'x';
        color: #fff;
        display: inline-flex;
        font-family: 'element-icons';
        font-size: smaller;
        transform: translate(2px, -5px);
      }
    }
  }
}
</style>
